import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

function PaymentsAPI(): BringozApi {
  return {
    base: `/payments`,
    infiniteScroll: {
      address: `/payments`,
      cmd: 'GET'
    },
    actions: {
      totals: {
        address: 'totals/summary',
        cmd: 'GET',
        updateable: false
      }
    }
  }
}
angular
  .module('bringoz.admin.payments')
  .factory('PaymentsAPI', PaymentsAPI);
